export const ACCOUNT = {
  ACCOUNT_INFO: "ACCOUNT_INFO",
  ACCOUNT_TOKEN: "ACCOUNT_TOKEN",
};
